__turbopack_context__.v({
  "addon": "landing-module__bxHgOq__addon",
  "addonDesc": "landing-module__bxHgOq__addonDesc",
  "addonList": "landing-module__bxHgOq__addonList",
  "addonName": "landing-module__bxHgOq__addonName",
  "addonPrice": "landing-module__bxHgOq__addonPrice",
  "addonText": "landing-module__bxHgOq__addonText",
  "addons": "landing-module__bxHgOq__addons",
  "addonsTitle": "landing-module__bxHgOq__addonsTitle",
  "btn": "landing-module__bxHgOq__btn",
  "btnAmb": "landing-module__bxHgOq__btnAmb",
  "btnGhost": "landing-module__bxHgOq__btnGhost",
  "btnTag": "landing-module__bxHgOq__btnTag",
  "chip": "landing-module__bxHgOq__chip",
  "chipGroup": "landing-module__bxHgOq__chipGroup",
  "chips": "landing-module__bxHgOq__chips",
  "ctaRow": "landing-module__bxHgOq__ctaRow",
  "demo": "landing-module__bxHgOq__demo",
  "demoCol": "landing-module__bxHgOq__demoCol",
  "done": "landing-module__bxHgOq__done",
  "doneActions": "landing-module__bxHgOq__doneActions",
  "doneIcon": "landing-module__bxHgOq__doneIcon",
  "doneIconWait": "landing-module__bxHgOq__doneIconWait",
  "doneText": "landing-module__bxHgOq__doneText",
  "doneTitle": "landing-module__bxHgOq__doneTitle",
  "doneWho": "landing-module__bxHgOq__doneWho",
  "eyebrow": "landing-module__bxHgOq__eyebrow",
  "field": "landing-module__bxHgOq__field",
  "fieldErr": "landing-module__bxHgOq__fieldErr",
  "fieldLabel": "landing-module__bxHgOq__fieldLabel",
  "fieldOpt": "landing-module__bxHgOq__fieldOpt",
  "fine": "landing-module__bxHgOq__fine",
  "flow": "landing-module__bxHgOq__flow",
  "foot": "landing-module__bxHgOq__foot",
  "footAddr": "landing-module__bxHgOq__footAddr",
  "footLink": "landing-module__bxHgOq__footLink",
  "footLogo": "landing-module__bxHgOq__footLogo",
  "footTitle": "landing-module__bxHgOq__footTitle",
  "footer": "landing-module__bxHgOq__footer",
  "form": "landing-module__bxHgOq__form",
  "get": "landing-module__bxHgOq__get",
  "getNo": "landing-module__bxHgOq__getNo",
  "getText": "landing-module__bxHgOq__getText",
  "getTitle": "landing-module__bxHgOq__getTitle",
  "gets": "landing-module__bxHgOq__gets",
  "hero": "landing-module__bxHgOq__hero",
  "heroCopy": "landing-module__bxHgOq__heroCopy",
  "heroEm": "landing-module__bxHgOq__heroEm",
  "heroGrid": "landing-module__bxHgOq__heroGrid",
  "heroTitle": "landing-module__bxHgOq__heroTitle",
  "inp": "landing-module__bxHgOq__inp",
  "inpErr": "landing-module__bxHgOq__inpErr",
  "lead": "landing-module__bxHgOq__lead",
  "links": "landing-module__bxHgOq__links",
  "logo": "landing-module__bxHgOq__logo",
  "logoMark": "landing-module__bxHgOq__logoMark",
  "mig": "landing-module__bxHgOq__mig",
  "migItem": "landing-module__bxHgOq__migItem",
  "migList": "landing-module__bxHgOq__migList",
  "migNote": "landing-module__bxHgOq__migNote",
  "migStrong": "landing-module__bxHgOq__migStrong",
  "migTitle": "landing-module__bxHgOq__migTitle",
  "mod": "landing-module__bxHgOq__mod",
  "modCode": "landing-module__bxHgOq__modCode",
  "modText": "landing-module__bxHgOq__modText",
  "modTitle": "landing-module__bxHgOq__modTitle",
  "mods": "landing-module__bxHgOq__mods",
  "nav": "landing-module__bxHgOq__nav",
  "navCta": "landing-module__bxHgOq__navCta",
  "navLogin": "landing-module__bxHgOq__navLogin",
  "pkg": "landing-module__bxHgOq__pkg",
  "pkgAmount": "landing-module__bxHgOq__pkgAmount",
  "pkgBadge": "landing-module__bxHgOq__pkgBadge",
  "pkgCta": "landing-module__bxHgOq__pkgCta",
  "pkgFeat": "landing-module__bxHgOq__pkgFeat",
  "pkgFeats": "landing-module__bxHgOq__pkgFeats",
  "pkgHot": "landing-module__bxHgOq__pkgHot",
  "pkgName": "landing-module__bxHgOq__pkgName",
  "pkgNote": "landing-module__bxHgOq__pkgNote",
  "pkgNoteTight": "landing-module__bxHgOq__pkgNoteTight",
  "pkgPer": "landing-module__bxHgOq__pkgPer",
  "pkgPerkList": "landing-module__bxHgOq__pkgPerkList",
  "pkgPerks": "landing-module__bxHgOq__pkgPerks",
  "pkgPerksTitle": "landing-module__bxHgOq__pkgPerksTitle",
  "pkgPrice": "landing-module__bxHgOq__pkgPrice",
  "pkgTag": "landing-module__bxHgOq__pkgTag",
  "pkgTrialLink": "landing-module__bxHgOq__pkgTrialLink",
  "pkgs": "landing-module__bxHgOq__pkgs",
  "pre": "landing-module__bxHgOq__pre",
  "preBox": "landing-module__bxHgOq__preBox",
  "preErr": "landing-module__bxHgOq__preErr",
  "quote": "landing-module__bxHgOq__quote",
  "quoteSrc": "landing-module__bxHgOq__quoteSrc",
  "quoteText": "landing-module__bxHgOq__quoteText",
  "root": "landing-module__bxHgOq__root",
  "row2": "landing-module__bxHgOq__row2",
  "sec": "landing-module__bxHgOq__sec",
  "secFlush": "landing-module__bxHgOq__secFlush",
  "secH": "landing-module__bxHgOq__secH",
  "secHTight": "landing-module__bxHgOq__secHTight",
  "secText": "landing-module__bxHgOq__secText",
  "secTitle": "landing-module__bxHgOq__secTitle",
  "shot": "landing-module__bxHgOq__shot",
  "shotCanvas": "landing-module__bxHgOq__shotCanvas",
  "shotReady": "landing-module__bxHgOq__shotReady",
  "step": "landing-module__bxHgOq__step",
  "stepDesc": "landing-module__bxHgOq__stepDesc",
  "stepName": "landing-module__bxHgOq__stepName",
  "stepNo": "landing-module__bxHgOq__stepNo",
  "submit": "landing-module__bxHgOq__submit",
  "wrap": "landing-module__bxHgOq__wrap",
});
